import { useQuery } from '@tanstack/react-query'
import useAuth from '@/features/auth/hooks/use-auth'
import { queryKeys } from '@/shared/constants/query-keys'
import { societiesAdminV2Service } from '../services/societies-admin-v2.service'

/**
 * Sociedades activas (`{ id: soc_, name }`) para los selects v2 que las
 * cascadean —el form de proyectos, y más adelante otros consumidores—. Sólo
 * corre con sesión staff v2; los datos casi no cambian, así que se cachean largo.
 */
export const useSocietiesV2LookupQuery = () => {
  const { auth } = useAuth()
  const accessToken = auth?.v2AccessToken ?? ''
  return useQuery({
    queryKey: queryKeys.societies.lookupV2(),
    queryFn: async () => await societiesAdminV2Service.lookup(accessToken),
    enabled: Boolean(accessToken),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false
  })
}
